import { map } from 'lodash';
import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';
import { transformSnakeToCamel } from '@adjust/dashboard-core/api/api.utils';

const http = httpFactory({ baseURL: configurationURL.paymaster.baseUrl });

export const getInvoices = (limit?: number) => {
  const requestParams = limit ? { params: { 'page[limit]': limit } } : undefined;
  return http
    .get('/invoices', {
      ...requestParams,
      ignore404: true,
      transformResponse: transformSnakeToCamel,
    })
    .then(resp => map(resp.data.data, 'attributes'))
    .catch(() => null);
};

export const getCurrentCharge = () =>
  http
    .get('/current_charge', {
      ignore404: true,
      transformResponse: transformSnakeToCamel,
    })
    .then(resp => resp.data.data.attributes)
    .catch(() => null);
